import { IDeleteItemFolhaPagamentoUseCase } from "../../../presentation/useCases/delete/delete_item_folha_pagamento_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * DeleteItemFolhaPagamentoUseCase
 */

export class DeleteItemFolhaPagamentoUseCase implements IDeleteItemFolhaPagamentoUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async deleteItemFolhaPagamento(
    idItemFolhaPagamento: number,
  ): Promise<void> {
    await this.repository.deleteItemFolhaPagamento(idItemFolhaPagamento);
  }
}
